import type { Config, ConfigService } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, InstanceManagementState } from '../../../models'
import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'
import { INSTANCE_MANAGEMENT_CONSTS } from '../instance-management.consts'

export class SetEnabledServiceConfigAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<InstanceManagementState, any>,
    { config, enabled }: { config: Config; enabled: boolean },
  ): Promise<Config> {
    const configService = CONTAINER.get<ConfigService>(TYPES.ConfigService)
    const updatedConfig = await configService.setEnabled(config, enabled)
    commit(INSTANCE_MANAGEMENT_CONSTS.mutations.updateServiceConfig, updatedConfig)
    return updatedConfig
  }
}
